module.exports = __webpack_public_path__ + "static/media/info.76a8b762.png";